<div class="container-xl mt-md-4">
  <div class="row">
    <div class="col">
      <!-- <table class="table table-sm">
        <tbody> -->
          <ng-container *ngFor="let category of categories">
            <ng-container *ngIf="category.services.length > 0">
              <div style="margin-left: -15px; margin-right: -15px; padding-left: 15px;" class="border-top border-bottom w-100 py-2 font-weight-bolder">{{ category.name }}</div>

              <ng-container *ngFor="let service of category.services; let index = index;">
                <div class="row align-items-center border-bottom pb-4 service-item" [class.mb-4]="index === 0" [class.mt-3]="index === 0" [class.my-4]="index !== 0">
                  <div class="col-12 col-md-8">
                    {{ service.name }}
                  </div>
                  <div class="col-8 col-md-2">
                    <div class="row">
                      <div class="col-5 col-md-12">{{ service.price | currency}}</div>
                      <div class="col-7 col-md-12"><small>{{ service.time_taken }}</small></div>
                    </div>
                  </div>
                  <div class="col-4 col-md-2">
                    <a [routerLink]="'/book-appointment/' + service.id" class="btn btn-outline-dark btn-sm book-button">
                      <span (click)="setActiveSalon(salon, $event)">Book Now</span>
                    </a>
                  </div>
                </div>
              </ng-container>

              <!-- <tr *ngFor="let service of category.services; let index = index;">
                <td class="border-top-0">
                  <div class="row align-items-center">
                    <div class="col-12 col-md-8">
                      {{ service.name }}
                    </div>
                    <div class="col-8 col-md-2">
                      <div class="row">
                        <div class="col-5 col-md-12">{{ service.price | currency}}</div>
                        <div class="col-7 col-md-12"><small>{{ service.time_taken }}</small></div>
                      </div>
                    </div>
                    <div class="col-4 col-md-2">
                      <a [routerLink]="'/book-appointment/' + service.id" class="btn btn-outline-dark btn-sm book-button">
                        <span (click)="setActiveSalon(salon, $event)">Book Now</span>
                      </a>
                    </div>
                  </div>
                </td>
              </tr> -->
              <tr style="height: 2rem;"></tr>
            </ng-container>
          </ng-container>
        <!-- </tbody>
      </table> -->
    </div>
  </div>
</div>